import ExpiryCard from 'components/ExpiryCard';
import VisitCard from 'components/VisitCard';
import { Customer } from 'models';
import React from 'react';
import { StyledBalanceCard, Wrapper, VisitsBox, ProgressionPoint } from './UserVisits.styles';

interface UserVisitsProps {
  userVisits: Customer;
}

function UserVisits({ userVisits }: UserVisitsProps) {
  const {
    pointsDetails: { points },
    loyaltyDetails: { currentCycleVisits, cycleExpiryDate },
  } = userVisits;

  const visits = [
    {
      visits: '1',
      suffix: 'st',
      points: 10,
    },
    {
      visits: '2',
      suffix: 'nd',
      points: 20,
    },
    {
      visits: '3',
      suffix: 'rd',
      points: 30,
    },
    {
      visits: '4',
      suffix: 'th',
      points: 40,
    },
  ];

  return (
    <Wrapper>
      <VisitsBox aria-label="Visits Card">
        {visits.map((visit, idx) => {
          const currentVisit = idx + 1;

          return (
            <React.Fragment key={`visit ${currentVisit}`}>
              <VisitCard
                visits={visit.visits}
                suffix={visit.suffix}
                points={visit.points}
                isCompleted={currentVisit <= currentCycleVisits}
                tier={currentVisit}
              />

              {currentVisit !== visits.length && (
                <ProgressionPoint
                  isComplete={currentVisit <= currentCycleVisits - 1}
                  tier={currentVisit}
                />
              )}
            </React.Fragment>
          );
        })}
      </VisitsBox>

      <ExpiryCard cycleVisits={currentCycleVisits} expiry={cycleExpiryDate} />

      <StyledBalanceCard points={points} pageTitle="Main Page" />
    </Wrapper>
  );
}

export default UserVisits;
